import {BottomNavigation, BottomNavigationAction, Box, Drawer, IconButton, Stack, Typography} from "@mui/material";
import {Close} from "@mui/icons-material";
import {useState} from "react";

/**
 * Barre d'onglets fixée en bas de l'écran + tiroir (Drawer) avec les options de la section
 * sélectionnée. Pensé pour un agencement mobile où on veut garder le contenu principal
 * (ex. URL + aperçu, ou nom + aperçu) visible en haut, sans options entre les deux.
 */
function SectionedMobileNav({sections}) {
    const [activeKey, setActiveKey] = useState(sections[0]?.key);
    const [drawerOpen, setDrawerOpen] = useState(false);

    const current = sections.find((s) => s.key === activeKey) || sections[0];

    const open = (key) => {
        setActiveKey(key);
        setDrawerOpen(true);
    };

    return (
        <>
            <BottomNavigation
                showLabels
                value={drawerOpen ? current?.key : false}
                onChange={(e, value) => open(value)}
                sx={{
                    position: 'fixed', left: 0, right: 0, bottom: 0, zIndex: 1200,
                    height: 'auto', overflowX: 'auto',
                    borderTop: 1, borderColor: 'divider',
                    '& .MuiBottomNavigationAction-root': {
                        minWidth: 64, px: 1, pt: 1, pb: 0.75, color: 'text.secondary',
                    },
                    '& .Mui-selected': {color: 'primary.main'},
                }}
            >
                {sections.map((s) => (
                    <BottomNavigationAction key={s.key} value={s.key} label={s.label} icon={s.icon}/>
                ))}
            </BottomNavigation>

            <Drawer
                anchor="bottom"
                open={drawerOpen}
                onClose={() => setDrawerOpen(false)}
                PaperProps={{sx: {borderTopLeftRadius: 16, borderTopRightRadius: 16, maxHeight: '75vh'}}}
            >
                <Box sx={{p: 3, pb: 4, display: 'flex', flexDirection: 'column', gap: 2}}>
                    <Stack direction="row" alignItems="center" justifyContent="space-between">
                        <Typography variant="h6">{current?.label}</Typography>
                        <IconButton onClick={() => setDrawerOpen(false)} aria-label="Fermer" size="small">
                            <Close/>
                        </IconButton>
                    </Stack>
                    {current?.node}
                </Box>
            </Drawer>
        </>
    );
}

export default SectionedMobileNav;
